/* eslint-disable react/no-multi-comp */
import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { List } from '@material-ui/core';

import SideBarList from './components/SideBarList/SideBarList';

const SideBarTree = (props) => {
  const { pages, signOut, ...rest } = props;
  const location = useLocation();

  return (
    <List>
      {pages.reduce((items, page) => reduceChildRoutes({ location, items, page, ...rest }), [])}
      {signOut}
    </List>
  );
};

SideBarTree.propTypes = {
  depth: PropTypes.number,
  pages: PropTypes.array,
  signOut: PropTypes.node,
};

SideBarTree.defaultProps = {
  depth: 0,
  pages: [],
  signOut: undefined,
};

const reduceChildRoutes = (props) => {
  const { location, items, page, depth } = props;
  const selected = matchPath(location.pathname, {
    path: page.href,
    exact: true,
  });

  items.push(
    <SideBarList
      depth={depth}
      href={page.href}
      icon={page.icon}
      key={page.title}
      selected={Boolean(selected)}
      title={page.title}
    >
      {page.children && <SideBarTree depth={depth + 1} pages={page.children} />}
    </SideBarList>
  );

  return items;
};

const SideBar = (props) => {
  const { pages, signOut, component: Component, ...rest } = props;

  return (
    <Component {...rest}>
      <SideBarTree depth={0} pages={pages} signOut={signOut} />
    </Component>
  );
};

SideBar.propTypes = {
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  signOut: PropTypes.node,
};

SideBar.defaultProps = {
  component: 'nav',
  signOut: undefined,
};

export default SideBar;
